export default __webpack_public_path__ + "3a8bbbd6b72a8793740b466a7d40dd69.svg";